import { getEditDefaultActionsData, getPreviewDefaultActionsData, getPrimaryDefaultActionsData, getRemoveDefaultActionsData } from '../default/getDefaultChickletHoverActions';
import I18n from 'I18n';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
const SUPPORTED_ID_TO_TYPE = {
  '0-1': 'CONTACT'
};
const CampaignChickletHoverActions = args => {
  const {
    fromObjectTypeId
  } = args;
  const sendOpenEditCampaignsPanel = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_EDIT_CAMPAIGN_ENGAGEMENT_MODAL);

  // For CONTACT type, add custom edit engagement action
  if (SUPPORTED_ID_TO_TYPE[fromObjectTypeId] === 'CONTACT') {
    const editEngagementAction = {
      dataSeleniumTest: 'chicklet-edit-engagement-btn',
      dataTestId: 'chicklet-edit-engagement-btn',
      label: I18n.text('cardAssociatedObjects.chicklet.ChickletHoverActionsDropdown.campaignsEdit'),
      onClick: () => {
        sendOpenEditCampaignsPanel({
          contactId: args.fromObjectId,
          campaignObjectId: `${args.objectId}`
        });
      }
    };
    return {
      PrimaryAction: getPreviewDefaultActionsData(args),
      SecondaryActions: [editEngagementAction, getRemoveDefaultActionsData(args)]
    };
  }

  // Default behavior for non-CONTACT types
  return {
    PrimaryAction: getPreviewDefaultActionsData(args),
    SecondaryActions: [getPrimaryDefaultActionsData(args), getEditDefaultActionsData(args), getRemoveDefaultActionsData(args)]
  };
};
export default CampaignChickletHoverActions;